import { useState } from "react";
import { CONTACT } from "@/lib/constants";

export default function ContactForm({
  defaultType = "general",
  defaultSubject = "",
  defaultMessage = "",
  productName = null,
  compact = false,
  testIdPrefix = "contact",
}) {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", company: "", subject: defaultSubject, message: defaultMessage,
  });
  const onChange = (event) => setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  const submit = (event) => {
    event.preventDefault();
    const subject = form.subject || (productName ? `Product enquiry: ${productName}` : "Website enquiry");
    const body = [
      `Enquiry type: ${defaultType}`, productName ? `Product: ${productName}` : "",
      `Name: ${form.name}`, `Email: ${form.email}`, `Phone: ${form.phone}`,
      `Company: ${form.company || "Not specified"}`, "", "Message:", form.message
    ].filter((line) => line !== null).join("\n");
    // Opens the visitor's own mail application. It does not silently store or send data.
    window.location.href = `mailto:${CONTACT.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };
  const inputCls = "w-full px-4 py-3 rounded-md border border-slate-300 bg-white text-[#0F172A] placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#2A9D8F] focus:border-transparent transition-all";
  return (
    <form onSubmit={submit} data-testid={`${testIdPrefix}-form`} className="space-y-4">
      <div className={`grid ${compact ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"} gap-4`}>
        <input required name="name" value={form.name} onChange={onChange} placeholder="Full Name *" className={inputCls} data-testid={`${testIdPrefix}-name`} />
        <input required type="email" name="email" value={form.email} onChange={onChange} placeholder="Email *" className={inputCls} data-testid={`${testIdPrefix}-email`} />
        <input required name="phone" value={form.phone} onChange={onChange} placeholder="Phone / WhatsApp *" className={inputCls} data-testid={`${testIdPrefix}-phone`} />
        <input name="company" value={form.company} onChange={onChange} placeholder="Company / Clinic" className={inputCls} data-testid={`${testIdPrefix}-company`} />
      </div>
      {!compact && <input name="subject" value={form.subject} onChange={onChange} placeholder="Subject" className={inputCls} data-testid={`${testIdPrefix}-subject`} />}
      <textarea required name="message" value={form.message} onChange={onChange} placeholder="Tell us about your requirement *" rows={compact ? 3 : 5} className={inputCls} data-testid={`${testIdPrefix}-message`} />
      <p className="text-sm text-slate-600">
        Selecting the button below opens an email draft in your mail app. Please press Send there to deliver your enquiry.
        Alternatively email <a className="text-[#2A9D8F] underline" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>.
      </p>
      <button type="submit" className="btn-accent w-full md:w-auto" data-testid={`${testIdPrefix}-submit`}>
        Continue to Email
      </button>
    </form>
  );
}
